module.exports = __webpack_public_path__ + "static/media/circular-arrow.83c18a02.svg";